import { useEffect, useState } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import apiService from "../../../../../../service/Api";

const ranges = ["0-100", "101-250", "251-500", "501-1000", "1000+"];

export default function TotalCapacityByVenueWidget() {
  const [seriesData, setSeriesData] = useState<
    { data: number[]; label: string }[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await apiService.get<{
          data: Record<string, Record<string, number>>;
        }>("/api/venues/dashboard/venue-types-by-capacity/");

        const data = res.data?.data;
        if (!data) {
          setError("No data available");
          return;
        }

        // Collect all venue types
        const typesSet = new Set<string>();
        ranges.forEach((range) => {
          Object.keys(data[range] || {}).forEach((type) => {
            if (type) typesSet.add(type);
          });
        });

        // Build series data
        const series = Array.from(typesSet).map((venueType) => {
          const values = ranges.map((range) => data[range]?.[venueType] ?? 0);
          return { data: values, label: venueType };
        });

        setSeriesData(series);
      } catch (err) {
        console.error("Failed to fetch venue capacity data:", err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <Typography>{error}</Typography>;

  return (
    <Card sx={{ height: "100%", borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Total Capacity by Venue Type
        </Typography>

        <BarChart
          xAxis={[
            {
              data: ranges,
              scaleType: "band",
              label: "Capacity Range",
            },
          ]}
          yAxis={[
            {
              label: "Number of Venues",
            },
          ]}
          series={seriesData}
          height={350}
        />
      </CardContent>
    </Card>
  );
}
